import {cookie} from "../lib/cookie";
import {writable} from 'svelte/store';
import {getDate, getYearsDif, yearsBeforeToday} from "../lib/lib";
import app from "./app";

let userObject = {
    id: null,
    lastname: null,
    firstname: null,
    email: null,
    vat: 24,
    status_id: 0,
    is_verified: 0,
    expires_at: null,
    shop_subscription_years: 0,
    document_subscription_years: 0,
    token: '',

    showLogin: false,
};

const {get, set, update, subscribe} = writable(userObject);

const user = {
    set,
    update,
    subscribe,

    getToken: () => {
        return userObject.token || '';
    },

    acronym: () => {
        if (!userObject.lastname && !userObject.firstname) {
            return '';
        }
        return (userObject.lastname ? userObject.lastname[0] : '') + (userObject.firstname ? userObject.firstname[0] : '');
    },

    initialize: () => {
        user.update(obj => {
            obj.token = cookie.get('hva-member') || null;
            return obj;
        });
    },

    setUser: data => {
        user.update(obj => {
            obj.id = data.id;
            obj.lastname = data.lastname;
            obj.firstname = data.firstname;
            obj.email = data.email;
            obj.region_id = data.region_id;
            obj.status_id = data.status_id;
            obj.is_verified = data.is_verified;
            obj.expires_at = data.expires_at;
            if (data.vat) {
                obj.vat = data.vat;
            }
            if (data.token) {
                obj.token = data.token;
            }

            user.saveCookie();
            return obj;
        });
    },

    clearToken: () => {
        user.update(obj => {
            obj.id = null;
            obj.token = '';
            user.saveCookie();
            return obj;
        });
    },

    saveCookie: () => {
        if (userObject.token) {
            cookie.create('hva-member', userObject.token);
        } else {
            cookie.delete('hva-member');
        }
    },

    deleteCookie: () => {
        cookie.delete('hva-member');
    },

    subscriptionExpired: () => {
        return getDate() > userObject.expires_at;
    },

    canAccessDocuments: () => {
        if (!userObject.expires_at) {
            return false;
        }
        return userObject.document_subscription_years >= yearsBeforeToday(userObject.expires_at);
    },

    canBuyServices: () => {
        if (!userObject.expires_at) {
            return false;
        }

        return userObject.shop_subscription_years >= yearsBeforeToday(userObject.expires_at);
    },

    isActive: () => {
        if (userObject.token) {
            return userObject.status_id == 1;
        }

        return true;
    },
}

export default user;